// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__GLiA1","modalForm":"UpgradeEpcsModal_modalForm__1L7tT","modalFooter":"UpgradeEpcsModal_modalFooter__16h9V"};